import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getOperationIndustrieStub } from '../../../../config/operations-industrie';

export default function RecuperationChaleurPage() {
  const parcours = getOperationIndustrieStub('recuperation-chaleur');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      crossLinks={[
        {
          label: 'Coups de pouce industriels',
          href: '/industrie/aides/coups-de-pouce',
          iconName: 'flame',
          hint: 'Bonification CEE possible sur la chaleur fatale',
        },
        {
          label: 'Fonds chaleur ADEME',
          href: '/industrie/aides/fonds-chaleur',
          iconName: 'thermometer',
          hint: "Cumul possible si chaleur de récupération valorisée",
        },
        {
          label: 'CEE IND',
          href: '/industrie/aides/cee-ind',
          iconName: 'sparkles',
          hint: 'Prime CEE de base sur la fiche IND-UT-131',
        },
      ]}
      crossLinksAllLabel="Toutes les aides industrie"
      crossLinksAllHref="/industrie/aides"
    />
  );
}
